import { milestone } from '../jsonEditor/milestoneJsonEditorConfig.js';
import { versionConfig, regionConfig, languageConfig, statusConfig } from '../options.js';
export const milestones = {
    type: 'milestones',
    contentType: 'milestone',
    editor: 'json',
    editorConfig: milestone,
    editorContext: 'root',
    editorTitle: { name: 'title', placeholder: 'title' },
    supportContent: ['articles', 'milestones'],
    title: 'Milestone',
    plural: 'Milestones',
    endpoint: 'milestones',
    queryProperties: [
        'id',
        'modified',
        'slug',
        'status',
        'type',
        'title',
        'content',
        'created',
        'region',
        'language',
        'contentType',
        'client',
        'scoringLevel',
        'scoringMilestone',
        'rank',
        'milestoneCategories',
        '_legacyId',
    ],
    version: versionConfig,
    listing: {
        type: 'grid',
        gridColumns: ['title'],
        gridCombineProperty: 'slug',
        gridContentType: 'milestones',
        gridDecode: ['title'],
        gridFilters: [
            {
                label: 'Status',
                key: 'status',
                uppercase: false,
                default: false,
                value: 'published',
                options: statusConfig.options,
            },
            {
                label: 'Region',
                key: 'region',
                uppercase: false,
                default: true,
                options: regionConfig.options,
            },
            {
                label: 'Language',
                key: 'language',
                uppercase: false,
                default: true,
                options: languageConfig.options,
            },
        ],
        gridHasChildren: true,
        gridJoin: { properties: [] },
        gridSearch: [{ key: 'title', combine: true }],
        gridSupportContent: [],
    },
    sidebar: {
        status: [
            {
                label: 'Status',
                name: 'status',
                input: 'select',
                options: [
                    { label: 'Draft', value: 'draft' },
                    { label: 'Pending', value: 'pending' },
                    { label: 'Publish', value: 'published' },
                ],
            },
            {
                label: 'Created',
                name: 'created',
                input: 'datetime-local',
            },
        ],
        version: [
            { label: 'Slug', name: 'slug', input: 'text' },
            { label: 'Client', name: 'client', input: 'multiselect' },
            regionConfig,
            languageConfig,
        ],
        versioned: true,
        category: [{ label: 'Milestone Categories', name: 'milestoneCategories', type: 'milestone' }],
        images: [{ label: 'Featured Image', name: 'image' }],
    },
    meta: [
        {
            label: 'Legacy ID',
            name: '_legacyId',
            input: 'number',
            description: 'Legacy ID for the document (if applicable).',
        },
    ],
    validate: [],
};
//# sourceMappingURL=milestones.js.map